"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const react_router_dom_1 = require("react-router-dom");
const context_1 = require("../../../context");
const reusables_1 = require("../../../comps/reusables");
const graphql_1 = require("../../../graphql");
const BaseAuthModal_1 = require("./BaseAuthModal");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const react_2 = require("@osmosys/react");
exports.ResetPasswordModal = props => {
    const { match } = use_react_router_1.default();
    const invitationQuery = react_hooks_1.useQuery(graphql_1.isUserTokenValid, {
        fetchPolicy: 'cache-and-network',
        // notifyOnNetworkStatusChange: true,
        variables: {
            key: 'passwordResetToken',
            token: match.params.token,
        },
    });
    if (invitationQuery.loading) {
        return react_1.default.createElement(reusables_1.Loading, null);
    }
    const altLinks = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(context_1.OsmosysAppContext.Consumer, null, ({ appSettings }) => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_router_dom_1.Link, { to: "/login" }, "Log in"),
            ",",
            appSettings && appSettings.allowSignups && (react_1.default.createElement(react_1.default.Fragment, null,
                ' ',
                react_1.default.createElement(react_router_dom_1.Link, { to: "/signup" }, "sign up"),
                ",")),
            ' ',
            "or",
            ' ',
            react_1.default.createElement(react_router_dom_1.Link, { to: "/forgot-password" }, "request another password reset link"),
            ".")))));
    if (invitationQuery.error || !invitationQuery.data) {
        return (react_1.default.createElement(BaseAuthModal_1.BaseAuthModal, Object.assign({ osysSubType: "resetPassword.fail", title: "Could not reset password", fields: [], mutation: graphql_1.signupWithInvite, buttonText: "Sign up", showButton: false, variables: {
                email: '',
                fullName: '',
            }, linkComp: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "TransactionalEmail", action: "read", apolloError: invitationQuery.error }),
                react_1.default.createElement("p", { className: "text-muted mt-4" }, altLinks),
                react_1.default.createElement("p", { className: "text-muted" },
                    "If you think this was in error, please",
                    ' ',
                    react_1.default.createElement("a", { href: "mailto:contact@yellowbrim.com" }, "contact support"),
                    ".")) }, props)));
    }
    return (react_1.default.createElement(BaseAuthModal_1.BaseAuthModal, Object.assign({ osysSubType: "resetPassword.success", title: "Reset password", fields: ['password'], mutation: graphql_1.resetPassword, buttonText: "Change password and login", emailIsDisabled: true, getVars: values => ({
            data: {
                id: invitationQuery.data &&
                    invitationQuery.data.isUserTokenValid &&
                    invitationQuery.data.isUserTokenValid.id,
                password: values.password,
                resetCode: values.token,
            },
        }), linkComp: react_1.default.createElement(react_1.default.Fragment, null, !invitationQuery.error ? (react_1.default.createElement("p", { className: "text-muted" },
            "This link will expire",
            ' ',
            moment_1.default(invitationQuery.data &&
                invitationQuery.data.isUserTokenValid &&
                invitationQuery.data.isUserTokenValid
                    .passwordResetTokenExpiresAt).fromNow(),
            ". ",
            react_1.default.createElement(react_router_dom_1.Link, { to: "/login" }, "Login"),
            ".")) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "TransactionalEmail", action: "read" // hideWarningIcon
                , apolloError: invitationQuery.error }),
            react_1.default.createElement("p", { className: "text-muted mt-2" }, altLinks)))) }, props)));
};
exports.default = exports.ResetPasswordModal;
//# sourceMappingURL=ResetPasswordModal.js.map